import { GraphicsCheckImage, GraphicsDogImage, Stack, Typography } from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { ApiCard, ApiDigitalWalletToken } from '../../../openapi';
import { Card } from '../CreateCardPage/Card';
import { useWalletName } from '../../DigitalWalletToken/useWalletName';

function StatusView({
  title,
  subtitle,
  image,
}: {
  title: string;
  subtitle: string;
  image: React.ReactNode;
}) {
  return (
    <Stack
      spacing={2}
      alignItems="center"
      width="100%"
      sx={{ '& img': { width: '100%', maxWidth: 256 } }}
    >
      {image}
      <Typography variant="h4">{title}</Typography>
      <Typography variant="body1">{subtitle}</Typography>
    </Stack>
  );
}

export function DigitalWalletTokenStatus({
  token,
  card,
}: {
  token: ApiDigitalWalletToken;
  card: ApiCard;
}) {
  const { t } = useTranslation();
  const wallet = useWalletName(token);

  switch (token.state) {
    case 'PENDING':
    case 'PROVISIONING':
      return (
        <Card
          holderName={card.cardHolderName}
          cardDesign={card.cardDesign}
          lastFour={card.lastFour}
        />
      );
    case 'PROVISIONED':
      return (
        <StatusView
          title={t('You confirmed that you want to add the card to {{wallet}}.', { wallet })}
          subtitle={t('Now you can go back to {{wallet}} setup and follow the remaining steps.', {
            wallet,
          })}
          image={<GraphicsCheckImage alt={t('Positive check')} />}
        />
      );
    case 'TERMINATED':
      return (
        <StatusView
          title={t('You declined to add the card to {{wallet}}.', { wallet })}
          subtitle={t('Please go back to {{wallet}} setup and follow the remaining steps.', {
            wallet,
          })}
          image={<GraphicsDogImage alt={t('Sad dog in {{productName}} style')} />}
        />
      );
    default:
      return null;
  }
}
